/**
 * Created by LiYongLiang
 */
import { isSSAI } from './utils.js';
import HWRJSBridge from './jsbridge'
const HWRecognizer = {
  // 当前题目ID
  questionId: '',
  // 手写识别 1：支持，0：不支持
  hwrIsSupported: 0,
  // 手写识别是否阻塞渲染结果，默认为false，即不阻塞
  isWriteBlock: false,
  // 多空题滚动顶起开始为第几题，默认为 3
  scrollStart: 3,
  // 检查是否已存在手写识别原生组件，存在的话也能证明客户端支持手写识别
  checkInited() {
    const isSpad = isSSAI();
    const isSupportHWR = isSpad && this.hwrIsSupported === 1;
    return (
      isSupportHWR &&
      !!sessionStorage.getItem(`HWRecognizer_${this.questionId}`)
    );
  },
  // 检查是否展示了手写识别
  checkShow() {
    return !!sessionStorage.getItem('HWRecognizer_show');
  },
  /**
   * 初始化组件，非常关键
   * @method  init
   * @param { String }
   * @author LiYongLiang
   */
  init(options) {
    const {
      questionId,
      hwrIsSupported,
      accountId,
      userId,
      subjectId,
      courseId,
      lessonId,
      studyCardId,
      scrollStart,
    } = options;
    this.questionId = questionId;
    this.hwrIsSupported = hwrIsSupported || 0;
    this.scrollStart = scrollStart || 3;
    // 如果在展示手写识别，就清除状态；
    const isShow = this.checkShow();
    const isSpad = isSSAI();
    if (isShow) this.clear();
    // 非灰度、非学习机环境、学习机不支持手写识别协议三种情况，init无法进行
    if (!isSpad || this.hwrIsSupported === 0) return; // 非SPad或非灰度，都不得初始化手写识别组件
    let params = {
      userId,
      courseId,
      lessonId,
      accountId,
      subjectId,
      questionId,
      interval: 500,
    };
    if (studyCardId) {
      params.studyCardId = studyCardId;
    }
    HWRJSBridge.init(params, () => {
      sessionStorage.setItem(`HWRecognizer_${this.questionId}`, 1);
    });
  },
  /**
   * 展示手写识别组件
   */
  show(index) {
    const isHWRInited = this.checkInited(); // 是否已经初始化了手写步骤
    if (!isHWRInited) return;
    // 只有在第${this.scrollStart}个填空及以上才需要设置paddingBottom
    const paddingBottom = index + 1 >= this.scrollStart
      ? parseFloat((window.innerHeight * 0.4).toFixed(2)) + 'px'
      : '0px';
    document.body.style.paddingBottom = paddingBottom;
    HWRJSBridge.show({ index }, () => {
      sessionStorage.setItem('HWRecognizer_show', 1);
    });
  },
  /**
   * 隐藏手写识别组件
   * 此方法千万不能导致APP崩溃
   */
  hide() {
    // 恢复body的paddingBottom
    document.body.style.paddingBottom = '0px';
    HWRJSBridge.hide();
    this.clear();
  },
  // 清除题目的缓存信息
  clearQuestion() {
    const isHWRInited = this.checkInited(); // 是否已经初始化了手写步骤
    if (isHWRInited) {
      sessionStorage.removeItem(`HWRecognizer_${this.questionId}`);
      this.clear();
    }
  },
  // 删除一些存储状态
  clear() {
    sessionStorage.removeItem('HWRecognizer_show');
  },
  // 获取上传的图片状态
  async getInfos() {
    const isHWRInited = this.checkInited(); // 是否已经初始化了手写步骤
    if (!isHWRInited) {
      return null;
    }
    const data = await HWRJSBridge.getInfos();
    return data;
  },
};

export default HWRecognizer
